














































import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Getter } from 'vuex-class'
import { Watch } from 'vue-property-decorator'
import moment from 'moment'

import { Brand, Filter, Campaign, SpecialDate, UserSettings } from '../store/timeline'

const vis = require('vis')
const vue2vis = require('vue2vis')

interface RangeChangeEvent {
    start: Date
    end: Date
    byUser: boolean
    event: Event
}

const colorRe = /#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/

function autoForegroundColor(backgroundColor: string) {
    const result = backgroundColor.toLowerCase().match(colorRe)
    if (result === null) {
        return '#000000'
    }
    const r = parseInt(result[1], 16) / 255
    const g = parseInt(result[2], 16) / 255
    const b = parseInt(result[3], 16) / 255
    const lum = 0.21 * r + 0.72 * g + 0.07 * b
    return lum > 0.6 ? '#000000' : '#ffffff'
}

@Component({
    components: {
        VueTimeline: vue2vis.Timeline,
    },
})
export default class Timeline extends Vue {
    @State(s => s.timeline.campaigns) campaigns!: Campaign[]
    @State(s => s.timeline.brands) brands!: Brand[]
    @State(s => s.timeline.filter) filter!: Filter
    @State(s => s.timeline.specialDates) specialDates!: SpecialDate[]
    @State(s => s.timeline.userSettings.permissions) permissions!: UserSettings
    @Getter('timeline/items') items!: any[]

    fab = false

    styleElement: HTMLStyleElement | null = null

    options = {
        selectable: true,
        editable: {
            updateTime: true,
        },
        height: '100%',
        orientation: 'top',
        zoomMin: 7 * 24 * 60 * 60 * 1000, // 7 days
        zoomMax: 18 * 30 * 24 * 60 * 60 * 1000, // 1 1/2 years
        moment(date: Date) {
            return vis.moment(date).utc()
        },
        snap: (date: Date) => moment(date).utc().startOf('day'),
        onMove: (item: any) => {
            const path = `${item.type}/${item.id.substr(1)}`
            let data: any = {}
            switch (item.type) {
                case 'range':
                    data.start_date = moment(item.start).format('YYYY-MM-DD')
                    data.end_date = moment(item.end).format('YYYY-MM-DD')
                    break
                case 'point':
                    data.date = moment(item.start).format('YYYY-MM-DD')
                    break
                default:
                    throw Error(`Unsupported item type: ${item._type}`)
            }
            this.$store.dispatch('api/patch', { path, data })
        },
    }

    mounted() {
        this.$store.dispatch('timeline/load')
        this.createStyleElement()
    }

    beforeDestroy() {
        this.destroyStyleElement()
    }

    get groups() {
        return this.brands
            .filter(brand => (
                !this.filter.brands.length ||
                this.filter.brands.indexOf(brand.id) >= 0
            ))
            .map(brand => ({
                id: brand.id,
                order: brand.index,
                content: `<img src="${brand.logo}">`,
            }))
    }

    addRange() {
        this.$router.push({
            name: 'range',
            params: {
                rangeId: '0',
            },
        })
    }

    addPoint(type: string) {
        this.$router.push({
            name: 'point',
            params: {
                pointId: '0',
                type,
            },
        })
    }

    openItem(id: string) {
        switch (id[0]) {
            case 'r':
                this.$router.push({
                    name: 'range',
                    params: {
                        rangeId: id.substr(1),
                    },
                })
                break
            case 'p':
                this.$router.push({
                    name: 'point',
                    params: {
                        pointId: id.substr(1),
                    },
                })
                break
            default:
                console.log(`openItem for id ${id} not implemented`)
                break
        }
    }

    onRangeChanged(ev: RangeChangeEvent) {
        this.$store.dispatch('timeline/setViewport', {
            start: ev.start,
            end: ev.end,
        })
    }

    createStyleElement() {
        this.destroyStyleElement()
        const styles = [
            ...this.campaigns.map(c => `
                .vis-item.vis-range.c${c.id},
                .vis-item.vis-point.c${c.id} .vis-dot {
                    background-color: ${c.color};
                    border-color: ${c.color};
                }
                .vis-item.vis-range.c${c.id} {
                    color: ${autoForegroundColor(c.color)};
                }
            `),
            ...this.specialDates.map(s => `
                .vis-background.special-date.s${s.id} {
                    background-color: ${s.color};
                }
                .vis-background.special-date.s${s.id} .label {
                    color: ${autoForegroundColor(s.color)};
                }
            `),
        ]
        this.styleElement = document.createElement('style')
        this.styleElement.type = 'text/css'
        this.styleElement.innerHTML = styles.join('\n')
        document.getElementsByTagName('head')[0].appendChild(this.styleElement)
    }

    destroyStyleElement() {
        if (this.styleElement) {
            this.styleElement.remove()
            this.styleElement = null
        }
    }

    @Watch('campaigns')
    campaignsChanged() {
        this.createStyleElement()
    }

    setViewport(begin: Date, end: Date) {
        const timeline: any = this.$refs.timeline
        timeline.setWindow(begin, end)
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Timeline.vue